export default "__VITE_ASSET__0c04b5c7__"